module.exports = __webpack_public_path__ + "img/map-pattern-b.5ef41323.png";